<template>
  <div class="container-xl mt-4">
    <div class="row row-cards">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">商店設定</h3>
          </div>
          <div class="card-body">
            <div
              :class="
                alertStatus === 'success'
                  ? 'alert alert-success'
                  : 'alert alert-danger'
              "
              v-show="alertStatus !== ''"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <form pb-autologin="true" autocomplete="off">
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">商店名稱</label>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="小明的店"
                    v-model="form.storeName"
                    pb-role="username"
                    :disabled="!checkPermission"
                  />
                  <small class="form-hint">顯示給付款者的商店標題</small>
                </div>
              </div>
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">網站網址</label>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="http://yourWebSiteURL"
                    v-model="form.storeDomain"
                    pb-role="password"
                    :disabled="!checkPermission"
                  />
                  <small class="form-hint"> 網站網址 </small>
                </div>
              </div>
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">呼叫網址</label>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="http://yourWebSiteURL/addPoint"
                    v-model="form.callbackUrl"
                    :disabled="!checkPermission"
                  />
                  <small class="form-hint"
                    >由 USD2PAY
                    回傳呼叫的網站網址，專門負責接收儲值/轉帳成功資訊</small
                  >
                </div>
              </div>
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">回傳網址</label>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="http://yourWebSiteURL/shopCompleted"
                    v-model="form.returnUrl"
                    :disabled="!checkPermission"
                  />
                  <small class="form-hint"
                    >用戶儲值/轉帳完成後，跳轉回您指定網址</small
                  >
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-md-6 col-sm-4"></div>
                <div class="col-md-6 col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <button
                        class="btn btn-outline-success w-100"
                        data-toggle="modal"
                        data-target="#key-modal"
                        :disabled="!checkSecretPermission"
                      >
                        金鑰及商店ID
                      </button>
                    </div>
                    <div class="col-sm-6">
                      <button
                        type="button"
                        class="btn btn-outline-primary w-100"
                        :disabled="!checkPermission"
                        @click.prevent="storeSetting"
                      >
                        設定
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
    <div
      class="modal modal-blur fade"
      id="key-modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">金鑰及商店ID</h5>
            <button
              type="button"
              class="btn-close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <h3>金鑰</h3>
            <div class="alert alert-success text-break" role="alert">
              {{ key }}
            </div>
            <h3>商店ID</h3>
            <div class="alert alert-success text-break" role="alert">
              {{ merchantId }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      alertMsg: "",
      alertStatus: "",
      token: "",
      key: "",
      merchantId: "",
      form: {
        storeName: "",
        storeDomain: "",
        callbackUrl: "",
        returnUrl: "",
      },
      checkPermission: false,
      checkSecretPermission: false,
    };
  },
  methods: {
    async storeSetting() {
      if (
        this.form.storeName === "" ||
        this.form.storeDomain === "" ||
        this.form.callbackUrl === "" ||
        this.form.returnUrl === ""
      ) {
        this.alertStatus = "error";
        this.alertMsg = "請填寫資訊";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/setting`;
        const vm = this;
        try {
          const res = await this.$http.patch(api, vm.form, {
            headers: { Authorization: `Bearer ${this.token}` },
          });
          if (res.data.status !== "success") {
            throw "error";
          }
          this.alertStatus = "success";
          this.alertMsg = "設定成功";
        } catch (err) {
          if (err.response.status === 401) {
            this.$parent.$parent.isExpired = true;
            this.$parent.$parent.checkSessionExpired()
          }
          this.alertStatus = "error";
          this.alertMsg = "錯誤";
        }
      }
    },
    async getStoreSetting() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/setting`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.merchantId = res.data.data.id;
        this.form.storeName = res.data.data.merchantSetting.storeName;
        this.form.storeDomain = res.data.data.merchantSetting.storeDomain;
        this.form.callbackUrl = res.data.data.merchantSetting.callbackUrl;
        this.form.returnUrl = res.data.data.merchantSetting.returnUrl;
        this.checkPermission = true;
        await this.getkey();
      } catch (err) {
        if (err.response.status === 401) {
          this.alertStatus = "error";
          this.alertMsg = "請驗證手機號碼及信箱";
        } else {
          this.alertStatus = "error";
          this.alertMsg = "無法取得資料";
        }
      }
    },
    async getkey() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/secret`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.key = res.data.data.secret;
        this.checkSecretPermission = true;
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
        this.alertStatus = "error";
        this.alertMsg = "金鑰及商店ID將在您的商店設定驗證完成後取得";
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getStoreSetting();
  },
};
</script>
